import { Injectable } from '@angular/core';

@Injectable()
export class CacheService {

    private _cache: { [namespace: string]:  Map<number | string, any> } = {};

    constructor() { }

    setItem<T>(namespace: string, key: number | string, item: T): T {

        if (!this._cache[namespace]) {
            this._cache[namespace] = new Map();
        }

        this._cache[namespace].set(key, item);

        return item;
    }

    hasItem(namespace: string, idKey: number | string): boolean {

        if (!this._cache[namespace]) {
            return false;
        }

        return this._cache[namespace].has(idKey);
    }

    getItem<T = any>(namespace: string, idKey: number | string): T {

        if (!this._cache[namespace]) {
            return undefined;
        }

        return this._cache[namespace].get(idKey);
    }

    clearCache(): void {
        this._cache = {};
    }

    clearNamespace(namespace: string): void {
        if (this._cache[namespace]) {
            this._cache[namespace].clear();
        }
    }

    clearItem(namespace: string, key: number): void {

        if (!this._cache[namespace]) {
            this._cache[namespace] = new Map();
        }

        this._cache[namespace].delete(key);
    }

}
